import { useEffect, useState } from "react";
import { useIntersectionObserver } from "usehooks-ts";

import { getDispensaryPromotions } from "@/api/requests/getDispensaryPromotions";
import { DispensaryPromotion } from "@/custom-types/Promotions";

const useDispensaryPromotions = (id: number, perPage = 3) => {
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [promotions, setPromotions] = useState<DispensaryPromotion[]>();

  const { ref, isIntersecting } = useIntersectionObserver({
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (isIntersecting) {
      getDispensaryPromotions(id, perPage * (page - 1), perPage)
        .then(({ data, metadata }) => {
          setTotalCount(metadata.totalCount);
          setPromotions([...(promotions || []), ...data]);
        })
        .catch((e) => {
          console.error("Error fetching dispensary promotions:", e);
        });
    }
  }, [isIntersecting, page, id]);

  return {
    page,
    promotions,
    ref,
    setPage,
    totalCount,
  };
};

export default useDispensaryPromotions;
